import type { IComponentController } from "angular";

export default class SitesListComponentController implements IComponentController {}
